export default __webpack_public_path__ + "static/media/rm1.9321c4dc.png";